export const Spacer: React.FC<{
  level: 4 | 3 | 2 | 1.5 | 1 | 0.5 | 0.25;
}> = ({ level }) => (
  <div
    className={
      level === 4
        ? 'tw-mt-[4rem]'
        : level === 3
          ? 'tw-mt-[3rem]'
          : level === 2
            ? 'tw-mt-[2rem]'
            : level === 1.5
              ? 'tw-mt-[1.5rem]'
              : level === 1
                ? 'tw-mt-[1rem]'
                : level === 0.5
                  ? 'tw-mt-[0.5rem]'
                  : level === 0.25
                    ? 'tw-mt-[0.25rem]'
                    : ''
    }
  />
);
